<template>
  <span class="loading-screen fade-in">
      <v-progress-circular
        class="loading-circle"
        :size="100"
        :width="5"
        color="colorPrimary2"
        indeterminate
      />
  </span>
</template>

<script>
  export default {
    name: "LoadingBar",
  }
</script>

<style lang="scss">
  @import "src/styles/_mixins.scss";

  .loading-screen {
    width:100%;
    height:100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
  }
  .loading-circle {
    position: absolute;
    left: calc(50% - 50px);
    top: calc(50% - 50px);
  }
</style>